export interface CreateUserRoleScopeInput {
  organizationId: string;
  userEmail: string;
  roleId: string;
  roleName: string;
  firstName: string;
  lastName: string;
  scopeId: string;
  objectName: string;
  objectId: string;
  createNew?: boolean;
}
